import { render, staticRenderFns } from "./cImgUploader_new.vue?vue&type=template&id=1a778c22&scoped=true"
import script from "./cImgUploader_new.vue?vue&type=script&lang=js"
export * from "./cImgUploader_new.vue?vue&type=script&lang=js"
import style0 from "./cImgUploader_new.vue?vue&type=style&index=0&id=1a778c22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a778c22",
  null
  
)

export default component.exports